import { render, staticRenderFns } from "./TitleSection.vue?vue&type=template&id=961c353a&scoped=true"
import script from "./TitleSection.vue?vue&type=script&lang=js"
export * from "./TitleSection.vue?vue&type=script&lang=js"
import style0 from "./TitleSection.vue?vue&type=style&index=0&id=961c353a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c353a",
  null
  
)

export default component.exports